import React ,{useEffect, useState} from "react";
import { Suspense } from "react";
import { Route, Routes } from "react-router-dom";
import { getRoutes  } from "./Routes";
import PrivateRoute from "./PrivateRoutes";
import Sidebar from "../components/Sidebar/Sidebar";
import MobileSidebar from "../components/Sidebar/MobileSidebar";
import Header from "../components/Header/Header";
import Footer from "../components/Footer/Footer";
import { CommonMessageProvider } from "../common/CommonMessage";
import {useNavigate,useLocation} from "react-router-dom"

const AppRoutes = () => {
  const routes = getRoutes();

  const navigate = useNavigate();
  const location = useLocation();

  const token = localStorage.getItem("token");

  useEffect(() => {
    const isOnRoot = location.pathname === "/";
    const isOnPrivatePath = routes.some(
      (route) => route.isPrivate && route.path === location.pathname
    );

    if (token && isOnRoot) {
      navigate("/dashboard");
    } else if (!token && isOnPrivatePath) {
      navigate("/");
    }
  }, [token, location.pathname, routes, navigate]);


  const [isMobile, setIsMobile] = useState(false);
  const [mobileSidebar, setMobileSidebar] = useState(false);

  useEffect(() => {
    const isMobileHandler = () => {
      setIsMobile(window.innerWidth <= 992);
    };

    isMobileHandler(); // Set initial value
    window.addEventListener("resize", isMobileHandler);
    return () => window.removeEventListener("resize", isMobileHandler);
  }, []);
  return (
    <>
      <CommonMessageProvider>
        <Suspense>
          <Routes>
            {routes.map((route, index) => (
              <Route
                path={route?.path}
                key={"route_" + index}
                element={
                  route?.isLayout && route.isPrivate ? (
                    <PrivateRoute redirectPath="/">
                        {!isMobile && <Sidebar />}
                        <div className="rightSide">
                          <Header onMenuClick={() => setMobileSidebar(true)} />
                          {isMobile && (
                            <MobileSidebar
                              mobileSidebar={mobileSidebar}
                              setMobileSidebar={setMobileSidebar}
                            />
                          )}
                          <route.element />
                          <Footer />
                        </div>
                      </PrivateRoute>
                  ) : !route?.isLayout && route.isPrivate? (
                    <PrivateRoute redirectPath="/">
                      <route.element />
                   </PrivateRoute>
                  ):(
                    // <route.element />
                    <route.element />
                  )
                }
              />
            ))}
          </Routes>
        </Suspense>
      </CommonMessageProvider>
    </>
  );
};

export default AppRoutes;
